// extracted by mini-css-extract-plugin
export default {"form":"reset_form__8Y9Bu","title":"reset_title__dQ6gK","info":"reset_info__80329","spinner":"reset_spinner__zkA5v","goToLogin":"reset_goToLogin__mJQrh"};